import { LANGUAGE } from "2g-i18n";

import PATHS_CZECH from "./cs";
import PATHS_ENGLISH from "./en";

export default {
  [LANGUAGE.CZECH]: PATHS_CZECH,
  [LANGUAGE.ENGLISH]: PATHS_ENGLISH
};
